import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import CircleIcon from '@mui/icons-material/Circle';

export default function TermsDialog({
  open,
  onClose,
  handleAcceptTermsClick,
  termsAccepted,
}) {
  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          width={'100%'}
        >
          <Typography
            color="grey.900"
            variant="body2"
            component="span"
            fontSize={16}
            fontWeight={600}
          >
            Genie Transcribe : Terms and Conditions
          </Typography>
          <IconButton size="small" onClick={onClose}>
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            flex: '1 1 auto',
            overflow: 'auto',
            '& .MuiList-root': {
              m: 0,
              '.MuiListItemIcon-root': {
                marginTop: '4px',
                minWidth: 0,
                mr: 1,
                '.MuiSvgIcon-root ': {
                  fontSize: '8px',
                },
              },
              '.MuiListItem-root': {
                alignItems: 'flex-start',
                px: 0,
                py: 0.5,
              },
              '.MuiListItemText-root': {
                m: 0,
              },
            },
          }}
        >
          <Typography
            color={'grey.900'}
            variant="body2"
            fontSize={13}
            marginBottom={2}
            fontWeight={600}
          >
            Version 1, Effective from [15th Aug,25] | VENDX Genie Transcribe
          </Typography>
          <Typography
            color={'text.primary'}
            variant="body2"
            fontSize={13}
            marginBottom={3}
          >
            Welcome to{' '}
            <Typography
              component="span"
              variant="body2"
              fontSize={13}
              color="grey.900"
              fontWeight={600}
            >
              VENDX Genie Transcribe
            </Typography>{' '}
            ("Genie Transcribe"), an AI-powered transcription and meeting
            summarization tool provided by{' '}
            <Typography
              component="span"
              variant="body2"
              fontSize={13}
              color="grey.900"
              fontWeight={600}
            >
              MavenVista Technologies Pvt. Ltd.
            </Typography>{' '}
            ("MavenVista"). Please carefully read and acknowledge the following
            terms before using Genie Transcribe. By accessing or using this
            service, you explicitly agree to be bound by these terms.
          </Typography>
          <Stack spacing={1} direction="row" marginBottom={2}>
            <Avatar
              sx={{
                bgcolor: 'primary.50',
                width: '25px',
                height: '25px',
                fontSize: 16,
                color: 'primary.main',
              }}
              variant="rounded"
            >
              1
            </Avatar>
            <Stack direction="column" spacing={0.5}>
              <Typography
                component={'h4'}
                color={'grey.900'}
                fontSize={14}
                fontWeight={600}
                textTransform={'uppercase'}
              >
                User Responsibility and Consent
              </Typography>
              <List>
                <ListItem>
                  <ListItemIcon>
                    <CircleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={'text.primary'}
                        variant="body2"
                        fontSize={13}
                      >
                        You must obtain explicit consent from all meeting
                        participants before initiating transcription.
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <CircleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={'text.primary'}
                        variant="body2"
                        fontSize={13}
                      >
                        You must inform all participants that transcription is
                        processed using AI services and that no audio/video will
                        be stored after processing.
                      </Typography>
                    }
                  />
                </ListItem>

                <ListItem>
                  <ListItemIcon>
                    <CircleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={'text.primary'}
                        variant="body2"
                        fontSize={13}
                      >
                        You are solely responsible for compliance with
                        applicable laws and organizational policies regarding
                        recording and data processing.
                      </Typography>
                    }
                  />
                </ListItem>
              </List>
            </Stack>
          </Stack>
          <Stack spacing={1} direction="row" marginBottom={2}>
            <Avatar
              sx={{
                bgcolor: 'primary.50',
                width: '25px',
                height: '25px',
                fontSize: 16,
                color: 'primary.main',
              }}
              variant="rounded"
            >
              2
            </Avatar>
            <Stack direction="column" spacing={0.5}>
              <Typography
                component={'h4'}
                color={'grey.900'}
                fontSize={14}
                fontWeight={600}
                textTransform={'uppercase'}
              >
                No Audio/Video Storage
              </Typography>
              <List>
                <ListItem>
                  <ListItemIcon>
                    <CircleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={'text.primary'}
                        variant="body2"
                        fontSize={13}
                      >
                        Genie Transcribe does not store audio or video
                        recordings.
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <CircleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={'text.primary'}
                        variant="body2"
                        fontSize={13}
                      >
                        Audio/video is processed only for live transcription and
                        is deleted immediately after processing.
                      </Typography>
                    }
                  />
                </ListItem>

                <ListItem>
                  <ListItemIcon>
                    <CircleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={'text.primary'}
                        variant="body2"
                        fontSize={13}
                      >
                        Only text transcripts and AI-generated summaries are
                        stored for your convenience, allowing you to manage and
                        review meeting history.
                      </Typography>
                    }
                  />
                </ListItem>
              </List>
            </Stack>
          </Stack>
          <Stack spacing={1} direction="row" marginBottom={2}>
            <Avatar
              sx={{
                bgcolor: 'primary.50',
                width: '25px',
                height: '25px',
                fontSize: 16,
                color: 'primary.main',
              }}
              variant="rounded"
            >
              3
            </Avatar>
            <Stack direction="column" spacing={0.5}>
              <Typography
                component={'h4'}
                color={'grey.900'}
                fontSize={14}
                fontWeight={600}
                textTransform={'uppercase'}
              >
                Data Security and Privacy
              </Typography>
              <List>
                <ListItem>
                  <ListItemIcon>
                    <CircleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={'text.primary'}
                        variant="body2"
                        fontSize={13}
                      >
                        MavenVista uses enterprise-grade, industry-leading LLM
                        providers under strict contractual security and privacy
                        agreements.
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <CircleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={'text.primary'}
                        variant="body2"
                        fontSize={13}
                      >
                        All processing is conducted in compliance with the{' '}
                        <Typography
                          color={'text.primary'}
                          component="span"
                          fontWeight={600}
                          variant="body2"
                          fontSize={13}
                        >
                          Digital Personal Data Protection Act, 2023
                        </Typography>{' '}
                        and applicable data protection regulations.
                      </Typography>
                    }
                  />
                </ListItem>

                <ListItem>
                  <ListItemIcon>
                    <CircleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={'text.primary'}
                        variant="body2"
                        fontSize={13}
                      >
                        Transcription and summarization requests are processed
                        through secure, professionally managed AI services.
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <CircleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={'text.primary'}
                        variant="body2"
                        fontSize={13}
                      >
                        MavenVista does not share user transcripts or summaries
                        with third parties except for processing through trusted
                        AI providers.
                      </Typography>
                    }
                  />
                </ListItem>
              </List>
            </Stack>
          </Stack>
          <Stack spacing={1} direction="row" marginBottom={2}>
            <Avatar
              sx={{
                bgcolor: 'primary.50',
                width: '25px',
                height: '25px',
                fontSize: 16,
                color: 'primary.main',
              }}
              variant="rounded"
            >
              4
            </Avatar>
            <Stack direction="column" spacing={0.5}>
              <Typography
                component={'h4'}
                color={'grey.900'}
                fontSize={14}
                fontWeight={600}
                textTransform={'uppercase'}
              >
                Confidentiality of Information
              </Typography>
              <List>
                <ListItem>
                  <ListItemIcon>
                    <CircleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={'text.primary'}
                        variant="body2"
                        fontSize={13}
                      >
                        Users must exercise discretion when sharing sensitive or
                        confidential information during meetings.
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <CircleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={'text.primary'}
                        variant="body2"
                        fontSize={13}
                      >
                        MavenVista disclaims responsibility for unauthorized
                        disclosures that occur as a result of users inputting
                        confidential data into the service.
                      </Typography>
                    }
                  />
                </ListItem>
              </List>
            </Stack>
          </Stack>
          <Stack spacing={1} direction="row" marginBottom={2}>
            <Avatar
              sx={{
                bgcolor: 'primary.50',
                width: '25px',
                height: '25px',
                fontSize: 16,
                color: 'primary.main',
              }}
              variant="rounded"
            >
              5
            </Avatar>
            <Stack direction="column" spacing={0.5}>
              <Typography
                component={'h4'}
                color={'grey.900'}
                fontSize={14}
                fontWeight={600}
                textTransform={'uppercase'}
              >
                Data Retention and Deletion
              </Typography>
              <List>
                <ListItem>
                  <ListItemIcon>
                    <CircleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={'text.primary'}
                        variant="body2"
                        fontSize={13}
                      >
                        Users may delete transcripts and summaries at any time
                        through available platform features.
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <CircleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={'text.primary'}
                        variant="body2"
                        fontSize={13}
                      >
                        Data processed through third-party AI providers is
                        subject to their respective retention policies.
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <CircleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={'text.primary'}
                        variant="body2"
                        fontSize={13}
                      >
                        Accounts inactive for an extended period may be removed
                        in accordance with MavenVista’s account lifecycle
                        policy.
                      </Typography>
                    }
                  />
                </ListItem>
              </List>
            </Stack>
          </Stack>
          <Stack spacing={1} direction="row" marginBottom={2}>
            <Avatar
              sx={{
                bgcolor: 'primary.50',
                width: '25px',
                height: '25px',
                fontSize: 16,
                color: 'primary.main',
              }}
              variant="rounded"
            >
              6
            </Avatar>
            <Stack direction="column" spacing={0.5}>
              <Typography
                component={'h4'}
                color={'grey.900'}
                fontSize={14}
                fontWeight={600}
                textTransform={'uppercase'}
              >
                Acceptable Use
              </Typography>
              <List>
                <ListItem>
                  <ListItemIcon>
                    <CircleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={'text.primary'}
                        variant="body2"
                        fontSize={13}
                      >
                        You agree not to use Genie Transcribe to upload, record,
                        or process unlawful, harmful, defamatory, or misleading
                        content.
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <CircleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={'text.primary'}
                        variant="body2"
                        fontSize={13}
                      >
                        You must not attempt to bypass security features,
                        exploit system vulnerabilities, or use the service for
                        unauthorized purposes.
                      </Typography>
                    }
                  />
                </ListItem>
              </List>
            </Stack>
          </Stack>
          <Stack spacing={1} direction="row" marginBottom={2}>
            <Avatar
              sx={{
                bgcolor: 'primary.50',
                width: '25px',
                height: '25px',
                fontSize: 16,
                color: 'primary.main',
              }}
              variant="rounded"
            >
              7
            </Avatar>
            <Stack direction="column" spacing={0.5}>
              <Typography
                component={'h4'}
                color={'grey.900'}
                fontSize={14}
                fontWeight={600}
                textTransform={'uppercase'}
              >
                Account and Access
              </Typography>
              <List>
                <ListItem>
                  <ListItemIcon>
                    <CircleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={'text.primary'}
                        variant="body2"
                        fontSize={13}
                      >
                        Keep your login credentials secure. You are responsible
                        for all activities performed under your account.
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <CircleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={'text.primary'}
                        variant="body2"
                        fontSize={13}
                      >
                        Any misuse of Genie Transcribe under your account will
                        be deemed your responsibility.
                      </Typography>
                    }
                  />
                </ListItem>
              </List>
            </Stack>
          </Stack>
          <Stack spacing={1} direction="row" marginBottom={2}>
            <Avatar
              sx={{
                bgcolor: 'primary.50',
                width: '25px',
                height: '25px',
                fontSize: 16,
                color: 'primary.main',
              }}
              variant="rounded"
            >
              8
            </Avatar>
            <Stack direction="column" spacing={0.5}>
              <Typography
                component={'h4'}
                color={'grey.900'}
                fontSize={14}
                fontWeight={600}
                textTransform={'uppercase'}
              >
                Service Availability
              </Typography>
              <List>
                <ListItem>
                  <ListItemIcon>
                    <CircleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={'text.primary'}
                        variant="body2"
                        fontSize={13}
                      >
                        While MavenVista strives for uninterrupted service,
                        Genie Transcribe may be unavailable during maintenance,
                        upgrades, or unforeseen technical issues.
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <CircleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={'text.primary'}
                        variant="body2"
                        fontSize={13}
                      >
                        No service level guarantees (SLA) are provided for
                        availability or response time.
                      </Typography>
                    }
                  />
                </ListItem>
              </List>
            </Stack>
          </Stack>

          <Stack spacing={1} direction="row" marginBottom={2}>
            <Avatar
              sx={{
                bgcolor: 'primary.50',
                width: '25px',
                height: '25px',
                fontSize: 16,
                color: 'primary.main',
              }}
              variant="rounded"
            >
              9
            </Avatar>
            <Stack direction="column" spacing={0.5}>
              <Typography
                component={'h4'}
                color={'grey.900'}
                fontSize={14}
                fontWeight={600}
                textTransform={'uppercase'}
              >
                No Warranty
              </Typography>
              <List>
                <ListItem>
                  <ListItemIcon>
                    <CircleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={'text.primary'}
                        variant="body2"
                        fontSize={13}
                      >
                        Genie Transcribe is provided{' '}
                        <Typography
                          color={'text.primary'}
                          component="span"
                          fontWeight={600}
                          variant="body2"
                          fontSize={13}
                        >
                          "as-is"
                        </Typography>{' '}
                        and{' '}
                        <Typography
                          color={'text.primary'}
                          component="span"
                          fontWeight={600}
                          variant="body2"
                          fontSize={13}
                        >
                          "as-available"
                        </Typography>
                        , without warranties of any kind, express or implied.
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <CircleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={'text.primary'}
                        variant="body2"
                        fontSize={13}
                      >
                        MavenVista disclaims all implied warranties, including
                        merchantability, fitness for a particular purpose, and
                        non-infringement.
                      </Typography>
                    }
                  />
                </ListItem>
              </List>
            </Stack>
          </Stack>

          <Stack spacing={1} direction="row" marginBottom={2}>
            <Avatar
              sx={{
                bgcolor: 'primary.50',
                width: '25px',
                height: '25px',
                fontSize: 16,
                color: 'primary.main',
              }}
              variant="rounded"
            >
              10
            </Avatar>
            <Stack direction="column" spacing={0.5}>
              <Typography
                component={'h4'}
                color={'grey.900'}
                fontSize={14}
                fontWeight={600}
                textTransform={'uppercase'}
              >
                Limitation of Liability
              </Typography>
              <List>
                <ListItem>
                  <ListItemIcon>
                    <CircleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={'text.primary'}
                        variant="body2"
                        fontSize={13}
                      >
                        Under no circumstances shall MavenVista or its
                        affiliates, partners, officers, employees, or agents be
                        liable for any direct, indirect, incidental,
                        consequential, special, or punitive damages arising from
                        your use of Genie Transcribe.
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <CircleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={'text.primary'}
                        variant="body2"
                        fontSize={13}
                      >
                        For free-tier users, total liability is limited to the
                        allocated hours of service usage for Genie Transcribe as
                        determined and reserved by MavenVista, and MavenVista
                        reserves the right to modify or update these allocated
                        hours at its sole discretion in the future.
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <CircleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={'text.primary'}
                        variant="body2"
                        fontSize={13}
                      >
                        MavenVista is not responsible for business losses,
                        missed opportunities, or compliance failures resulting
                        from reliance on AI-generated transcripts or summaries.
                      </Typography>
                    }
                  />
                </ListItem>
              </List>
            </Stack>
          </Stack>

          <Stack spacing={1} direction="row" marginBottom={2}>
            <Avatar
              sx={{
                bgcolor: 'primary.50',
                width: '25px',
                height: '25px',
                fontSize: 16,
                color: 'primary.main',
              }}
              variant="rounded"
            >
              11
            </Avatar>
            <Stack direction="column" spacing={0.5}>
              <Typography
                component={'h4'}
                color={'grey.900'}
                fontSize={14}
                fontWeight={600}
                textTransform={'uppercase'}
              >
                Modification of Terms
              </Typography>
              <List>
                <ListItem>
                  <ListItemIcon>
                    <CircleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={'text.primary'}
                        variant="body2"
                        fontSize={13}
                      >
                        MavenVista reserves the right to modify these terms at
                        any time. Continued use of Genie Transcribe following
                        changes constitutes acceptance of the revised terms.
                      </Typography>
                    }
                  />
                </ListItem>
              </List>
            </Stack>
          </Stack>

          <Stack spacing={1} direction="row" marginBottom={2}>
            <Avatar
              sx={{
                bgcolor: 'primary.50',
                width: '25px',
                height: '25px',
                fontSize: 16,
                color: 'primary.main',
              }}
              variant="rounded"
            >
              12
            </Avatar>
            <Stack direction="column" spacing={0.5}>
              <Typography
                component={'h4'}
                color={'grey.900'}
                fontSize={14}
                fontWeight={600}
                textTransform={'uppercase'}
              >
                Severability
              </Typography>
              <List>
                <ListItem>
                  <ListItemIcon>
                    <CircleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={'text.primary'}
                        variant="body2"
                        fontSize={13}
                      >
                        If any provision of these terms is found to be
                        unenforceable or invalid by a court of competent
                        jurisdiction, the remaining provisions shall continue in
                        full force and effect. The unenforceable provision shall
                        be deemed modified to the minimum extent necessary to
                        make it enforceable while preserving the intent of the
                        original provision.
                      </Typography>
                    }
                  />
                </ListItem>
              </List>
            </Stack>
          </Stack>

          <Stack spacing={1} direction="row" marginBottom={2}>
            <Avatar
              sx={{
                bgcolor: 'primary.50',
                width: '25px',
                height: '25px',
                fontSize: 16,
                color: 'primary.main',
              }}
              variant="rounded"
            >
              13
            </Avatar>
            <Stack direction="column" spacing={0.5}>
              <Typography
                component={'h4'}
                color={'grey.900'}
                fontSize={14}
                fontWeight={600}
                textTransform={'uppercase'}
              >
                Governing Law and Jurisdiction
              </Typography>
              <List>
                <ListItem>
                  <ListItemIcon>
                    <CircleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={'text.primary'}
                        variant="body2"
                        fontSize={13}
                      >
                        These terms and your use of VENDX Genie are governed by
                        and construed in accordance with the laws of India. Any
                        disputes arising from these terms or your use of Genie
                        will be subject exclusively to the jurisdiction of the
                        courts located in Ahmedabad, Gujarat, India.
                      </Typography>
                    }
                  />
                </ListItem>
              </List>
            </Stack>
          </Stack>
          <Typography
            color={'grey.900'}
            variant="body2"
            fontSize={13}
            marginBottom={2}
            fontWeight={600}
          >
            By using VENDX Genie Transcribe, you confirm your explicit
            acceptance of these Terms and Conditions, your acknowledgment of the
            associated risks, and your commitment to comply with applicable
            consent and privacy requirements.
          </Typography>
          <Typography
            color={'grey.900'}
            variant="body2"
            fontSize={13}
            fontWeight={600}
          >
            MavenVista Technologies Pvt. Ltd.
          </Typography>
          <Typography color={'text.primary'} variant="body2" fontSize={13}>
            Ahmedabad, Gujarat, India
          </Typography>
        </Box>
        {/* <Box textAlign={"center"}>
                    <FormControlLabel
                        control={
                            <Checkbox size="small"/>
                        }
                        label={
                            <Typography 
                                variant="body2"
                                color="text.primary"
                                sx={{                                    
                                    "a":{
                                        color:"text.primary",
                                    }
                                }}
                            >
                                <Link href="#" underline="hover">
                                    Accept Terms and Conditions
                                </Link>{' '}
                                • {' '}
                                <Link href="#" underline="hover">
                                    Privacy Policy
                                </Link>
                            </Typography>
                        }
                        sx={{ m: 0 }} 
                    />
                </Box> */}
      </DialogContent>
      {!termsAccepted && (
        <DialogActions
          sx={{
            '&.MuiDialogActions-root': {
              pt: 0,
              justifyContent: 'center',
            },
          }}
        >
          <Button
            variant="outlined"
            color="primary"
            size="large"
            onClick={onClose}
          >
            Decline
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => {
              handleAcceptTermsClick();
            }}
          >
            Accept
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
}
